import 'url-search-params-polyfill';
import { blackList } from './config';

export function generateLinkToDebug(gameInfo) {
  return gameInfo.get('id');
}

export function generateToken(props, newCurrency) {
  console.log('generating token');

  //token-gbp_user_"+tokenID
  let currency = newCurrency ? newCurrency : props.launchOptions.get('ccy');
  let min = 1;
  let max = props.config.get('max_users');
  let tokenID = Math.ceil(Math.random() * (max - min)) + min;
  let token = 'token-' + currency.toLowerCase() + '_user_' + tokenID;

  return token;
}

export function generateLink(gameInfo, launchParams, urlLaunchOptions) {
  let link, baseURL;

  baseURL = getURL();

  //console.log('launchParams', launchParams);

  link = baseURL;
  link += '?token=' + launchParams.get('token'); //token-gbp_user_"+tokenID
  link += '&language=' + launchParams.get('language');
  link += '&ccy=' + launchParams.get('ccy');
  link += '&mode=' + gameInfo.get('tags').get('mode');
  link += '&host=' + gameInfo.get('host');
  link += '&game=' + gameInfo.get('game');
  link += '&variant=' + gameInfo.get('variant');
  link += launchParams.get('extraParams');

  //TODO Add urlLaunchOptions to link

  return link;
}

export function getGameInfoFromURL() {
  const params = new URLSearchParams(window.location.search);
  const game = params.get('launch-game');

  return game ? game : false;
}

export function getAdditionalParamsFromURL() {
  const params = new URLSearchParams(window.location.search);

  // remove launch-game
  params.delete('launch-game');

  const additionalParams = params.toString();

  return additionalParams ? `&${additionalParams}` : '';
}

export function redirectTo(link) {
  window.location.href = link;
}

export function getURL() {
  if (typeof window.location.origin === 'undefined')
    window.location.origin =
      window.location.protocol + '//' + window.location.host;

  if (process.env.NODE_ENV === 'development')
    return 'http://dev-endemol.playzido.com';

  return window.location.origin + '/';
}

export function inBlackList() {
  let host = window.location.hostname;

  let params = new URLSearchParams(window.location.search);
  let show = params.get('showGames');

  return blackList.indexOf(host) > -1 && (!show || show === 'false');
}



// WEBPACK FOOTER //
// ./src/Utils.js